<script>
  import { trim, capitalize, uppercase } from "../utils.js";
  import { AGE, GENDER, BOOL } from "../dico.js";
  import { HStack, Spacer } from "../component/layout";
  import { Email, validateEmail, Text, Choice } from "../component/widget";

  export let show;
  export let submit;
  export let cancel;

  export let guestId = null;
  export let attending = null;
  export let showAttending = false;
  export let attendindRequired = true;
  export let firstName = null;
  export let lastName = null;
  export let email = null;
  export let showEmail = true;
  export let placeholder = "Email";
  export let age = "A";
  export let gender = "F";
  export let food_restriction = null;
  export let showFoodRestriction = false;
  export let favorite_songs = null;
  export let showFavoriteSongs = false;
  export let age_val = null;

  let current = null;

  let showError;
  let errorMessage;

  $: showAgeVal = age != "A";

  const handle_submit = async () => {
    try {
      submit(
        capitalize(trim(firstName)),
        uppercase(trim(lastName)),
        trim(email),
        age,
        gender,
        guestId,
        attending,
        trim(food_restriction),
        trim(favorite_songs),
        age_val
      );
      reset();
    } catch (e) {
      showError = true;
      errorMessage = e;
    }
  };

  const handle_cancel = () => {
    reset();
    cancel();
  };

  const reset = () => {
    guestId = null;
    firstName = null;
    lastName = null;
    email = null;
    age = "A";
    gender = "F";
    current = "";
    attending = null;
    food_restriction = null;
    favorite_songs = null;
    showError = false;
    errorMessage = null;
    age_val = null;
  };

  const validate = (event) => {
    switch (event.target.name) {
      case "email":
        validateEmail(event.target);
        break;
      default:
        break;
    }
  };
</script>

{#if showError}
  <div class="error">Une erreur s'est produite: {errorMessage}</div>
{/if}
<form
  class:opened={show}
  on:submit|preventDefault={handle_submit}
  on:invalid={validate}
  on:changed={validate}
  on:input={validate}>
  {#if showAttending}
    <Choice
      id={"attending"}
      bind:value={attending}
      bind:current
      required={attendindRequired}
      label="Présent"
      showLabel
      icon="fas fa-glass-cheers"
      values={BOOL} />
  {/if}

  <Text
    id={"firstname"}
    reset
    required={attendindRequired}
    bind:value={firstName}
    icon="fas fa-user"
    label="Prénom"
    placeholder="Prénom"
    bind:current
    textTransform={"capitalize"} />

  <Text
    id={"lastname"}
    reset
    required
    bind:value={lastName}
    icon="fas fa-user"
    label="Nom"
    placeholder="Nom"
    bind:current
    textTransform={"uppercase"} />

  <!-- email -->
  {#if showEmail}
    <Email id={"email"} bind:value={email} bind:current {placeholder} />
  {/if}

  <!-- age -->
  <Choice
    id={"age"}
    label="Age"
    bind:value={age}
    bind:current
    icon="fas fa-user-clock"
    values={AGE} />

  {#if showAgeVal}
    <Text
      id={"age_val"}
      type="number"
      reset
      bind:value={age_val}
      icon="fas fa-user-clock"
      label="Age"
      placeholder="Age"
      bind:current />
  {/if}

  <!-- gender -->
  <Choice
    id={"gender"}
    bind:value={gender}
    bind:current
    label="Genre"
    icon="fas fa-venus-mars"
    values={GENDER} />

  {#if showFoodRestriction}
    <Text
      id={"food_restriction"}
      reset
      bind:value={food_restriction}
      icon="fas fa-utensils"
      label="Restrictions"
      placeholder="Restrictions alimentaires"
      bind:current />
  {/if}

  {#if showFavoriteSongs}
    <Text
      id={"favorite_songs"}
      reset
      bind:value={favorite_songs}
      icon="fas fa-music"
      label="Chansons"
      placeholder="La chanson qui vous fera danser !"
      bind:current />
  {/if}

  <HStack>
    <button class="cancel" type="button" on:click={handle_cancel}>
      <i class="fas fa-angle-double-up" />
      <span>Annuler</span>
    </button>
    <button class="primary" type="submit">
      <i class="fas fa-user-plus" />
      {#if guestId}
        <span>Modifier</span>
      {:else}
        <span>Ajouter</span>
      {/if}
    </button>
    <Spacer />
  </HStack>
</form>

<style>
  form {
    margin: 5px;
    border-radius: 15px;
    transform: scaleY(0);
    transform-origin: 50% 0;
    transition: none;
    height: 0;
  }
  form.opened {
    border: 2px solid var(--secondary-light-color);
    padding: 1em;
    transform: scaleY(1);
    transition: transform 0.3s ease-out;
    height: auto;
  }

  button {
    margin-left: 1em;
  }
</style>
